import { Box, Button, Menu, TextField, Typography } from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React, { useState } from "react";
import { ReactComponent as DiscussionIcon } from "Assets/Icons/Classroom/DiscussionIcon.svg";
import { ReactComponent as SendIcon } from "Assets/Icons/Classroom/SendIcon.svg";

const ReportIssue = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <>
      <Button
        variant="contained"
        sx={(theme) => ({
          background: "#F5F5F5",
          color: theme.palette.secondary.light,
        })}
        startIcon={<PrimaryIcon icon={DiscussionIcon} />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        Issues ?
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          "& .MuiMenu-paper": { maxWidth: "500px", width: "100%" },
          "& ul": {
            padding: "0px",
          },
        }}
        rounded
      >
        <Box width={"100%"}>
          <Typography
            display={"flex"}
            width={"100%"}
            variant="subtitle"
            fontWeight={500}
            color="white"
            sx={(theme) => ({
              background: theme.palette.primary.main,
              padding: "8px 16px",
            })}
          >
            Report Issue for Session
          </Typography>
          <Box
            sx={(theme) => ({
              background: theme.palette.background.default,
              minHeight: "300px",
            })}
          ></Box>
          <Box
            sx={(theme) => ({
              padding: "8px 16px",
            })}
            display={"flex"}
            gap={"8px"}
          >
            <TextField
              fullWidth
              color="primary"
              placeholder="What's your issue"
              size="small"
              variant="outlined"
            />
            <Button variant="contained" iconbutton>
              <PrimaryIcon
                height="20px"
                width="20px"
                color="white"
                icon={SendIcon}
              />
            </Button>
          </Box>
        </Box>
      </Menu>
    </>
  );
};

export default ReportIssue;
